"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var toggle_styles_1 = require("./toggle.styles");
var core_components_1 = require("@securityproducts/core-components");
function Toggle(props) {
    function toggleAndRecordEvent() {
        core_components_1.AnalyticsService.recordEvent("toggle-chart-metric");
        props.toggleMetric(props.id);
    }
    return (React.createElement("div", { className: toggle_styles_1.toggle, id: props.id + "-wrapper" },
        React.createElement("label", { id: "" + props.id, "data-qa": "toggle", "data-status": props.checked ? "checked" : "unchecked", className: props.checked ? "checked" : "unchecked" },
            React.createElement("span", { className: toggle_styles_1.toggler },
                React.createElement("input", { defaultChecked: props.checked, id: props.id, type: "checkbox", onClick: toggleAndRecordEvent }),
                React.createElement("span", { className: toggle_styles_1.checkmark })),
            props.keyIcon,
            React.createElement("span", { className: toggle_styles_1.text }, props.text))));
}
exports.Toggle = Toggle;
